import { Input } from 'antd';
import styled from 'styled-components';

export const InputCustom = styled(Input)`
  /* border-radius: 30px !important; */
`;

